import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home.jsx';
import SaintsChat from './pages/SaintsChat.jsx';
import BuddhaChat from './pages/BuddhaChat.jsx';
import BibleChat from './pages/BibleChat.jsx';
import Download from './pages/Download.jsx';
import About from './pages/AboutUs.jsx';
import Contact from './pages/Contact.jsx';
import Privacy from './pages/PrivacyPolicy';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';

// 스크롤 처리를 위한 컴포넌트
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/saintschat" element={<SaintsChat />} />
        <Route path="/buddhachats" element={<BuddhaChat />} />
        <Route path="/biblechats" element={<BibleChat />} />
        <Route path="/download" element={<Download />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;